import { Component, computed, inject, OnInit, signal } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../../core/utils";
import { noWhitespaceValidator } from "../../../../core/validators";
import { PageMode } from "../../../constants/enums";
import { IntpCountryVisitMemberModel } from "../../../models";
import { FormInputComponent } from "../../form";

@Component({
  selector: "adaa-intp-visit-member-modal",
  imports: [TranslatePipe, ReactiveFormsModule, FormInputComponent],
  templateUrl: "./intp-visit-member-modal.html",
  styleUrl: "./intp-visit-member-modal.scss",
})
export class IntpVisitMemberModalComponent implements OnInit {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _toastrService = inject(ToastrService);
  private readonly _translateService = inject(TranslateService);
  readonly modal = inject(NgbActiveModal);

  //Inputs
  pageMode = signal<PageMode>(PageMode.create);
  member = signal<IntpCountryVisitMemberModel | undefined>(undefined);

  //Props
  model: FormGroup;
  submitted = false;

  isViewMode = computed(() => this.pageMode() === PageMode.view);

  public get displayLabel(): string {
    const nameEN = this.model.get("nameEN")?.value;
    const nameAE = this.model.get("nameAE")?.value;

    return AdaaHelper.getPageLabel(nameAE, nameEN);
  }

  public ngOnInit(): void {
    this.model = this._prepareForm();

    const member = this.member();
    if (member) this.model.patchValue(member);
  }

  public save() {
    this.submitted = true;

    if (!this.model.valid) {
      this._toastrService.warning(this._translateService.instant("notification.warning.missing_info"));
      return;
    }

    this.modal.close(this.model.getRawValue());
  }

  private _prepareForm() {
    return this._formBuilder.group({
      id: null,
      fakeId: null,
      nameAE: [{ value: null, disabled: this.isViewMode() }, [Validators.required, noWhitespaceValidator()]],
      nameEN: [{ value: null, disabled: this.isViewMode() }, [Validators.required, noWhitespaceValidator()]],
      responsibilityAE: [{ value: null, disabled: this.isViewMode() }, [Validators.required, noWhitespaceValidator()]],
      responsibilityEN: [{ value: null, disabled: this.isViewMode() }, [Validators.required, noWhitespaceValidator()]],
      status: null,
    });
  }
}
